import { Model } from 'app/model/backendmodel';
import { AzureDataLakeLocation } from 'app/model/dataset/location/azure-datalake.location';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeLocation)
})
export class AzureDataLakeLocationAdapter extends FileLocationAdapter<AzureDataLakeLocation, Model.DatasetLocation> {
    public _toResource(store: AzureDataLakeLocation): Model.ADLSGen1Location {
        const resource: Model.ADLSGen1Location = {
            type: 'AzureDataLakeStoreLocation',
            fileName: ValueAdapter.toResource(store, AzureDataLakeLocation.FILE_NAME) || undefined,
            folderPath: ValueAdapter.toResource(store, AzureDataLakeLocation.FOLDER_PATH) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.ADLSGen1Location, owner: Named): AzureDataLakeLocation {
        const model = Owned.create<AzureDataLakeLocation>(AzureDataLakeLocation.MODEL, owner);
        ValueAdapter.toModel(model, AzureDataLakeLocation.FILE_NAME, resource.fileName);
        ValueAdapter.toModel(model, AzureDataLakeLocation.FOLDER_PATH, resource.folderPath);
        return model;
    }
}
